export const ALGO_TX_MIN_FEE='0.001';